package com.evoapps.evoshift.domain.model

/**
 * The requested document does not exist (yet). Callers usually show an empty state rather than
 * an error, e.g. a roster whose financials have not been calculated.
 */
class NotFoundException(what: String) : Exception("$what not found")
